import {ROUTES, ROLES} from '../../plugins/types';

export const getRoutes = function () {
    const common = [
        ROUTES.PRODUCTS,
        //ROUTES.PRINTERS,
        ROUTES.ORDERS
    ];
    const operatorRoutes = [
        ROUTES.ORDERS,
        ROUTES.PRINTERS
    ];
    const salesRoutes = [
        ROUTES.REGISTRATION
    ];
    const keyAccountRoutes = [
        ...common,
        ROUTES.ANALYTICS,
        ROUTES.ANALYTICS_SELECT,
        ROUTES.STATISTICS,
        ROUTES.ACCOUNT,
        ROUTES.PROMOTIONS,
        ROUTES.REGISTRATION,
        ROUTES.REGISTRATION_SHOP,
        ROUTES.REGISTRATION_USER,
        ROUTES.SHOPS
    ];
    const shopOwnerRoutes = [
        ...common,
        ROUTES.ACCOUNT,
        ROUTES.ANALYTICS,
        ROUTES.REGISTRATION,
        ROUTES.PROMOTIONS
    ];
    const partnerRoutes = [];
    const adminRoutes = [
        ...common,
        ROUTES.DEVICES,
        ROUTES.REGISTRATION,
        ROUTES.SHOPS,
        ROUTES.USERS,
        ROUTES.PROMOTIONS,
        ROUTES.ACCOUNT,
        ROUTES.ANALYTICS,
        ROUTES.ANALYTICS_SELECT,
        ROUTES.STATISTICS,
        ROUTES.BANNERS,
        ROUTES.PRICES,
        ROUTES.TEMPLATES,
        ROUTES.API_BROWSER,
        ROUTES.REGISTRATION_SHOP,
        ROUTES.REGISTRATION_USER,
        ''
    ];
    return {
        [ROLES.ADMIN]: adminRoutes,
        [ROLES.SALES]: salesRoutes,
        [ROLES.KEY_ACCOUNT]: keyAccountRoutes,
        [ROLES.SHOP_OWNER]: shopOwnerRoutes,
        [ROLES.OPERATOR]: operatorRoutes,
        [ROLES.PARTNER]: partnerRoutes
    };
};
